export function getImmutPath(path: string) {
  if (path === "") return [];
  return path
    .split(".")
    .map((p) => (isNaN(p as unknown as number) ? p : parseInt(p)));
}
